import { IJMSFormSections } from '@/pages/JMS/Managament/data/data';

export const NotesForm: IJMSFormSections = [
  {
    title: 'Notes',
    name: 'notes',
    items: [
      {
        name: 'officer',
        type: 'select',
        label: 'Officer',
        className: 'col-span-2',
        placeholder: '',
        items: 'getUsers',
      },
      {
        name: 'description',
        type: 'textarea',
        label: 'Note Description',
        className: 'col-span-2',
        placeholder: '',
      },
    ],
  },
];
